import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as fromCv from '../../store/reducers/cv/index';
import * as CvParseSelectors from '../../store/reducers/cv/cv-parse.selectors';
import * as CvParseActions from '../../store/actions/cv-parse.actions';
import { IActiveParsing, PARSE_STATE } from '../../interfaces/cv-parse';

@Injectable( {
  providedIn: 'root'
})
export class CvParseFacadeService {
  constructor(
    private store: Store<fromCv.CvModuleState>
  ) {}

  get activeParsingStatus$(): Observable<IActiveParsing> {
    return this.store.pipe(select(CvParseSelectors.selectActiveParsingStatus));
  }

  get cancelParsingStatus$(): Observable<{ error: boolean; loading: boolean }> {
    return this.store.pipe(select(CvParseSelectors.selectCancelParsingStatus));
  }

  get parsingResultStatus$(): Observable<{ cvId: number; error: boolean; loading: boolean }> {
    return this.store.pipe(select(CvParseSelectors.selectParsingResultStatus));
  }

  get parsingState$(): Observable<PARSE_STATE> {
    return this.store.pipe(select(CvParseSelectors.selectParsingState));
  }

  get uploadFileStatus$(): Observable<{ error: boolean; loading: boolean }> {
    return this.store.pipe(select(CvParseSelectors.selectUploadFileStatus));
  }

  get ribbonState$(): Observable<{ folded: boolean; show: boolean }> {
    return this.store.pipe(select(CvParseSelectors.selectRibbonState));
  }

  checkActiveParsing() {
    this.store.dispatch(CvParseActions.checkActiveParsing());
  }

  uploadFileToParse(userId: string, cvFile: File) {
    this.store.dispatch(CvParseActions.uploadFileToParse({ userId, cvFile }));
  }

  cancelActiveParsing(cvId: number) {
    this.store.dispatch(CvParseActions.cancelActiveParsing({ cvId }));
  }

  resetParsingState() {
    this.store.dispatch(CvParseActions.resetParsingState());
  }

  updateRibbonState(show: boolean, folded: boolean) {
    this.store.dispatch(CvParseActions.updateRibbonState({ folded, show }));
  }

  updateRibbonShowState( show: boolean) {
    this.store.dispatch(CvParseActions.updateRibbonShowState({ show }));
  }

  updateRibbonFoldedState(folded: boolean) {
    this.store.dispatch(CvParseActions.updateRibbonFoldedState({ folded }));
  }
}
